// extracted by mini-css-extract-plugin
export default {"changeLink":"uR-z","disabled":"vR-z","inline":"wR-z"};